import { AssetDataRenderingConditions } from '@brickwise/asset-validation/dist/asset/assetData';
import { AssetInvestmentDataRenderingConditions } from '@brickwise/asset-validation/dist/asset/investmentData';
import { useFormikContext } from 'formik';
import { matchRoutes, useLocation } from 'react-router-dom';
import { Routes } from 'src/router/Routes';

const collectStrings = (obj: any) => {
  const strings: string[] = []; // Create an array to hold the strings.

  function traverse(o: any) {
    for (const i in o) {
      if (o[i] !== null && typeof o[i] === 'object') {
        // If the value is an object or array, recurse into it.
        traverse(o[i]);
      } else if (typeof o[i] === 'string') {
        // If the value is a string, add it to the strings array.
        strings.push(o[i]);
      }
    }
  }

  traverse(obj); // Kick off the traversal with the main object.

  return strings; // Return the array of strings.
};

const locationToConditionalRenderingMap = {
  '/assets/:assetId/investment': AssetInvestmentDataRenderingConditions,
  '/assets/:assetId': AssetDataRenderingConditions,
  '/assets/create': AssetDataRenderingConditions,
};

const AllRoutes = collectStrings(Routes).map((path) => ({ path }));

export const useConditionalRendering = (fieldName?: string) => {
  if (!fieldName) {
    return true;
  }
  const location = useLocation();
  const pathPatternRes = matchRoutes(AllRoutes, location);
  const assetFormikValues = useFormikContext();

  if (!assetFormikValues) {
    return true;
  }

  if (pathPatternRes?.length !== 1) {
    return true;
  }

  const currentPathPattern = pathPatternRes[0].route.path as keyof typeof locationToConditionalRenderingMap;

  const currentMap = locationToConditionalRenderingMap[currentPathPattern];

  if (currentMap === undefined) {
    return true;
  }

  const shouldRenderField = currentMap[fieldName as keyof typeof currentMap];

  if (shouldRenderField === undefined || shouldRenderField === null) {
    return true;
  }

  return shouldRenderField(assetFormikValues.values as any);
};
